<template>
	<div>
		<frontoffice-header
			:bread-crumbs="breadCrumbs"
			:current-title="$gettext('Policy conditions')"
		/>
		<div v-if="latestDate">
			<h4>
				<translate :translate-params="{valid_from: latestDate}">
					Have you purchased a Tulip Assist insurance after %{valid_from}? Then the policy conditions below apply
				</translate>:
			</h4>
			<ul>
				<li
					v-for="version of latestVersions"
					:key="version.id"
				>
					<strong>{{ version.name }} <translate>Insurance</translate></strong>
					<ul>
						<li v-if="version.policyFile">
							<a
								:href="'/downloadpolicy?id='+version.policyFile.id"
								target="_blank"
							><translate>Policy Terms</translate> {{ version.name }}</a>
						</li>
						<li v-if="version.ipidFile">
							<insurance-card-button :id="version.ipidFile.id" />
						</li>
						<li v-if="version.tobFile">
							<a
								:href="'/downloadpolicy/tob?id='+version.tobFile.id"
								target="_blank"
							>Terms of Business {{ version.name }}</a>
						</li>
					</ul>
				</li>
			</ul>
			<div v-if="previousVersions.length > 0">
				<h4><translate>Have you previously purchased a Tulip Assist insurance? Please check the table for the corresponding policy conditions</translate>:</h4>
				<policy-file-table :product-versions="previousVersions" />
			</div>
		</div>
	</div>
</template>

<script>

import {
	axios,
} from '../../services/axios-service';
import {
	displayError,
} from 'laravel-front-library';

export default {

	name: 'DownloadPolicy',
	data () {
		return {
			latestVersions: [],
			previousVersions: [],
			breadCrumbs: {
				'/': this.$gettext('Home')
			},
		};
	},

	computed: {
		latestDate () {
			if (this.latestVersions.length > 0) {
				const date = new Date(this.latestVersions[0].validFrom.date);

				return date.toLocaleString(this.latestVersions[0].language + '-' + this.latestVersions[0].domain, {
					dateStyle: 'long'
				});
			}
			return null;
		}
	},

	mounted () {
		this.getVersionFiles();
	},

	methods: {
		/**
		 * Get al product versions and associated files for this domain
		 */
		getVersionFiles () {
			axios.get('/api/v0/productversions/activefiles').then(({
				data: data
			}) => {
				this.sortVersions(data);
			}).catch((error) => {
				displayError(this.$gettext('Something has gone wrong during data retrieval'));
				window.captureException(error);
			});
		},

		/**
		 * Sort product versions into time windows and separate the latest versions from the rest
		 *
		 * @param {Array} productVersions
		 * @returns {void}
		 */
		sortVersions (productVersions) {
			let windowValidFrom = productVersions[0].validFrom.date;
			let previousVersionsI = -1;
			let latestDate = true;

			productVersions.forEach((productVersion) => {
				if (productVersion.validFrom.date < windowValidFrom) {
					this.previousVersions.push([]);
					previousVersionsI += 1;
					latestDate = false;
					windowValidFrom = productVersion.validFrom.date;
				}
				if (latestDate) {
					this.latestVersions.push(productVersion);
				} else {
					this.previousVersions[previousVersionsI].push(productVersion);
				}
			});
		}
	}
};

</script>
